import { useState, useRef } from "react";
import PropTypes from "prop-types";

import { useOnClickOutside } from "../../hooks";
import { Paragraph2, SVG } from "../../components";
import { CalendarDropdownInputWrapper, OptionsList, Option, IconWrapper } from "./styled";

const CalendarDropdownInput = ({ id, options, value, onChange }) => {
  const [optionsVisible, setOptionsVisible] = useState(false);

  const optionsRef = useRef();
  useOnClickOutside(optionsRef, () => setOptionsVisible(false));

  return (
    <CalendarDropdownInputWrapper id={id} ref={optionsRef}>
      <button onClick={() => setOptionsVisible(true)}>
        <Paragraph2>{value}</Paragraph2>

        <IconWrapper optionsVisible={optionsVisible}>
          <SVG.DropdownArrowDown />
        </IconWrapper>
      </button>

      <OptionsList visible={optionsVisible} isAbsolute={true}>
        {options.map((option, index) => {
          return (
            <Option key={index} selected={option === value} onClick={() => onChange(option)}>
              <Paragraph2>{option}</Paragraph2>
            </Option>
          );
        })}
      </OptionsList>
    </CalendarDropdownInputWrapper>
  );
};

CalendarDropdownInput.propTypes = {
  id: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired
};

export default CalendarDropdownInput;
